import script from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordReset.vue?vue&type=style&index=0&id=ea21e906&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea21e906"]])

export default __exports__